import * as actionTypes from "../../constants";

export const setBatchIds = (event) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.BATCH_ID_FOR_UPLOAD, event: event });
  };
};
